module.exports = __webpack_public_path__ + "img/1.b500a3c2.png";